import styled from 'styled-components';

import { colors } from 'styles/colors';

export const OldPrice = styled.s`
  color: ${colors.textHelper};
  font-size: 75%;
  margin-right: 8px;
`;
